<template>
   <div id="left-sidebar" class="sidebar">
      <a href="javascript:void(0);" class="menu_toggle" id="geral_step2"><i class="fa fa-angle-left"></i></a>
      <div class="navbar-brand p-0">
         <div class="topbar-logo-header">
            <div class="">
               <img src="@/assets/images/sigap-icone.png" class="logo-icon" alt="logo icon" width="70">
            </div>
            <div class="">
               <h4 class="logo-text"><span class="d-block ml-0 font-22" :class="tema == 'dark' ? 'text-white' : 'text-black'">Sistema</span><small class="d-block font-12 weight-500">Gerencial</small></h4>
            </div>
         </div>
         <!-- <router-link to="/paginaInicial"><img src="@/assets/images/icon.png" alt="Mooli Logo" class="img-fluid logo"><span>CommuniTrack</span></router-link> -->
         <button type="button" class="btn-toggle-offcanvas btn btn-sm float-right"><i class="far fa-times"></i></button>
      </div>
      <div class="sidebar-scroll">
         <div class="user-account" id="geral_step1">
            <div class="user_div">
               <img :src="dadosUsuario.usuarioFoto == null ? '' : dadosUsuario.usuarioFoto" @error="imageError" class="user-photo" alt="User Profile Picture">
            </div>
            <div class="dropdown">
               <span>Boas-vindas</span>
               <a href="javascript:void(0);" class="dropdown-toggle user-name" data-toggle="dropdown">
                  <strong>{{ dadosUsuario.usuarioNome != null && dadosUsuario.usuarioNome.length > 17 ? dadosUsuario.usuarioNome.substring(0, 17) +'...' : dadosUsuario.usuarioNome }}</strong>
               </a>
               <ul class="dropdown-menu dropdown-menu-right account vivify flipInY">
                  <li><a href="javascript:;" class="p-1" @click="abrirEditarFoto"><i class="far fa-image font-13"></i>Editar foto</a></li>
                  <li><a href="javascript:;" class="p-1" @click="abrirEditarSenha"><i class="far fa-key font-13"></i>Editar senha</a></li>
                  <!-- <li><a href="javascript:;" class="p-1" @click="reativarTutoriais"><i class="far fa-question-circle font-13"></i>Reativar tutoriais</a></li> -->
                  <li class="divider"></li>
                  <li><a href="javascript:;" class="p-1" @click="deslogar"><i class="far fa-sign-out font-13"></i>Sair</a></li>
               </ul>
            </div>
         </div>

         <nav id="left-sidebar-nav" class="sidebar-nav">
            <ul id="main-menu" class="metismenu animation-li-delay">
               <li :class="$route.path == '/paginaInicial' ? 'active' : ''">
                  <router-link to="/paginaInicial"><i class="fa-home" :class="$route.path == '/paginaInicial' ? 'fas' : 'fal'"></i> <span>Página inicial</span></router-link>
               </li>

               <li class="header text-secondary mt-3" v-if="['Ver/Adicionar Usuários'].some(el => dadosUsuario.usuarioPermissoes.includes(el))">Configurações</li>
               <li :class="$route.path == '/usuarios' ? 'active' : ''" v-if="dadosUsuario.usuarioPermissoes.includes('Ver/Adicionar Usuários')">
                  <router-link to="/usuarios"><i class="fa-users" :class="$route.path == '/usuarios' ? 'fas' : 'fal'"></i> <span>Usuários</span></router-link>
               </li>

               <li class="header text-secondary mt-3" v-if="dadosUsuario.usuarioEntidade || ['Ver/Adicionar Sentenciados', 'Ver/Adicionar Entidades', 'Ver Alertas'].some(el => dadosUsuario.usuarioPermissoes.includes(el))">Controles</li>
               <li :class="$route.path == '/entidades' ? 'active' : ''" v-if="dadosUsuario.usuarioPermissoes.includes('Ver/Adicionar Entidades')">
                  <router-link to="/entidades"><i class="fa-building" :class="$route.path == '/entidades' ? 'fas' : 'fal'"></i> <span>Entidades</span></router-link>
               </li>
               <li :class="$route.path == '/sentenciados' ? 'active' : ''" v-if="dadosUsuario.usuarioPermissoes.includes('Ver/Adicionar Sentenciados')">
                  <router-link to="/sentenciados"><i class="fa-file-user" :class="$route.path == '/sentenciados' ? 'fas' : 'fal'"></i> <span>Sentenciados</span></router-link>
               </li>
               <!-- <li :class="$route.path == '/sentenciados' ? 'active' : ''" v-if="dadosUsuario.usuarioPermissoes.includes('Ver/Adicionar Sentenciados')">
                  <router-link to="/sentenciados"><i class="fa-file-user" :class="$route.path == '/sentenciados' ? 'fas' : 'fal'"></i> <span>Sentenciados</span></router-link>
               </li> -->
               <!-- <li :class="$route.path == '/processos' ? 'active' : ''" v-if="dadosUsuario.usuarioPermissoes.includes('Ver/Adicionar Processos')">
                  <router-link to="/processos"><i class="fa-gavel" :class="$route.path == '/processos' ? 'fas' : 'fal'"></i> <span>Processos</span></router-link>
               </li> -->
               <!-- <li :class="$route.path == '/sentencas' ? 'active' : ''" v-if="dadosUsuario.usuarioEntidade">
                  <router-link to="/sentencas"><i class="fa-suitcase" :class="$route.path == '/sentencas' ? 'fas' : 'fal'"></i> <span>Sentenças</span></router-link>
               </li> -->
               <li :class="$route.path == '/arquivos' ? 'active' : ''" v-if="dadosUsuario.usuarioPermissoes.includes('Ver/Adicionar Arquivos')">
                  <router-link to="/arquivos"><i class="fa-file" :class="$route.path == '/arquivos' ? 'fas' : 'fal'"></i> <span>Arquivos</span></router-link>
               </li>
               <!-- <li :class="$route.path == '/alertas' ? 'active' : ''" v-if="dadosUsuario.usuarioPermissoes.includes('Ver Alertas')">
                  <router-link to="/alertas"><i class="fa-bell" :class="$route.path == '/alertas' ? 'fas' : 'fal'"></i> <span>Alertas</span></router-link>
               </li> -->
            </ul>
         </nav>
      </div>
   </div>
</template>

<script>

import { mapState } from 'vuex'

export default {
	name: 'MenuLateral',
   computed: {
      ... mapState({
         dadosUsuario: state => state.dadosUsuario,
         tema: state => state.tema
      })
   },
   methods: {
      imageError : function (e) {
         this.$store.dispatch('imageError', e)
      },
      deslogar : function () {
			this.$store.dispatch('deslogar')
      },
      abrirEditarSenha : function () {
         this.$emit('abrirEditarSenha')
      },
      abrirEditarFoto : function () {
         this.$emit('abrirEditarFoto')
      },
      reativarTutoriais() {
         localStorage.removeItem('tour_geral')
         localStorage.removeItem('tour_add_user')
         localStorage.removeItem('tour_add_sentenciado')
         localStorage.removeItem('tour_card_sentenciado')
         window.location.reload()
      }
   }
}

</script>

<style scoped>
.user-account {
   background: rgba(163, 163, 163, 0.05);
   border-radius: .25rem;
   padding: 14px 15px;
   margin: 15px 10px 20px 10px;
   box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
   border: 1px solid rgba(255, 255, 255, 0.048);
   position: relative;
   z-index: 1000;
}

[data-theme="light"] .user-account {
   background: rgba(139, 139, 139, 0.075);
   border: 1px solid rgba(0, 0, 0, 0.08);
}

.user-account .dropdown-menu {
   z-index: 1001;
}
</style>